import React, { Component } from 'react';
import { Row, Col, Table, Pagination } from "react-bootstrap";
import Select from 'react-select';

import { CustomCard } from "../../../components/Card/CustomCard";

import { ConsultVerificaciones, CantidadVerificaciones } from '../../../funciones/AdministracionFunction';
import VerificacionPagoTable from "./VerificacionPagoTable";
let maxPaginas = 20;
class VerificacionPago extends Component {
    state = {
        cantVerif: <i className="fa fa-spinner fa-spin"></i>,
        verificaciones: [],
        preloader: <React.Fragment><i className="fa fa-spinner fa-spin"></i> Buscando</React.Fragment>,
        paginas: 0,
        pag: 1,
        pagSelect: { value: 1, label: '- 1 -' },
        cantVerificaciones: { value: 10, label: '- Mostrar 10 Verificaciones -' },
        preloader2: ""
    }

    componentWillMount = () => {
        CantidadVerificaciones((resp1) => {
            let pags = (resp1) / (this.state.cantVerificaciones.value);
            let pagis = 0;
            pagis = parseInt(pags)
            if (!pags % 1 == 0) pagis ++;
            this.setState({
                paginas: pagis,
                cantVerif: resp1,
            })
        })

        ConsultVerificaciones (this.state.pag, this.state.cantVerificaciones.value, (resp) => {
            let prel = "";
            if ((resp.length) === 0) prel = "No tienes transacciones por verificar";

            this.setState({
                verificaciones: resp,
                preloader: prel
            })
        })
    }

    ayuda = () => (
        <React.Fragment>
            <div align="justify">
                En esta sección podrás ver todos los registros de pagos realizados por los estudiantes.
            </div>
            <div className="custom-mt-10" align="justify">
                <strong>Importante: Antes de aceptar cualquier transacción primero verifica la cuenta bancaria.</strong>
            </div>
            <div className="custom-mt-10" style={{color:"#1f2f6e"}}><strong>Verificaciones Pendientes</strong></div>
            <div align="justify">
                Correrponde a las transacciones registradas por los estudiantes: 
            </div>
            <div className="custom-mt-10" style={{color:"#1f2f6e"}}><strong>Estudiante</strong></div>
            <div align="justify">
                Son los datos del estudiante (Cédula de Identidad y Nombre Completo)
            </div>
            <div className="custom-mt-10" style={{color:"#1f2f6e"}}><strong>Detalles del Pago</strong></div>
            <div align="justify">
                Se puede ver detalladamente el monto de la transacción (En la parte inferior derecha del registro), la fecha de la transacción, el banco y el Número de Referencia
            </div>
            <div className="custom-mt-10" style={{color:"#1f2f6e"}}><strong>Acciones</strong></div>
            <div align="justify">
                El botón <button className="btn btn-primary btn-xs" style={{borderWidth: 1}}><i className="fa fa-chevron-right"></i></button> permite desplegar las siguientes opciones:
            </div>
            <Row>
                <Col md={5} className="custom-mt-10">
                    <div className="text-primary" style={{cursor:"pointer", fontSize: 11, padding: 5}}><i className="fa fa-print"></i> Recibo de Pago</div>
                </Col>
                <Col md={7} align="justify" className="custom-mt-10">
                    Permite ver el recibo de pago de la transacción en formato pdf para su impresión
                </Col>
                <Col md={5}>
                    <div className="text-success" style={{cursor:"pointer", fontSize: 11, padding: 5}}><i className="fa fa-check-circle"></i> Aprobar Transacción</div>
                </Col>
                <Col md={7} align="justify">
                    Esta opción aprueba la transacción y agrega el pago al estado de cuenta del estudiante. También le envía un email con la notificación
                </Col>
                <Col md={5}>
                    <div className="text-danger" style={{cursor:"pointer", fontSize: 11, padding: 5}}><i className="fa fa-trash"></i> Cancelar Transacción</div>
                </Col>
                <Col md={7} align="justify">
                    Esta opción elimina la transacción y le envía una notificación al email del estudiante
                </Col>
            </Row>
        </React.Fragment>
    )   

    contenido = () => {
        let { cantVerif, verificaciones, preloader, preloader2, cantVerificaciones, pagSelect, paginas } = this.state;

        const styles = {
            padding: 5, fontSize: 12
        }

        let listVerify = () => {
            if (verificaciones.length === 0) return (
                <tr>
                    <td align="center" colSpan={3} style={styles}>{preloader}</td>
                </tr>
            )
            return (
                verificaciones.map(option => (
                    <VerificacionPagoTable key={option.id} datos={option} updList = {() => {
                        ConsultVerificaciones (this.state.pag, this.state.cantVerificaciones.value, (resp) => {
                            let prel = "";
                            if ((resp.length) === 0) prel = "No tienes transacciones por verificar";
                
                            this.setState({
                                verificaciones: resp,
                                cantVerif: resp.length,
                                preloader: prel
                            })
                        })
                    }}/>
                ))
            )
        }

        let cambiaVerificaciones = (cantVerificaciones) => {
            this.setState({
                cantVerificaciones,
                preloader2: <i className="fa fa-spinner fa-spin"></i>
            }, () => {
                CantidadVerificaciones((resp1) => {
                    let pags = (resp1) / (this.state.cantVerificaciones.value);
                    let pagis = 0;
                    pagis = parseInt(pags)
                    if (!pags % 1 == 0) pagis ++;
                    this.setState({
                        paginas: pagis,
                        cantVerif: resp1,
                    })
                })
        
                ConsultVerificaciones (this.state.pag, this.state.cantVerificaciones.value, (resp) => {
                    let prel = "";
                    if ((resp.length) === 0) prel = "No tienes transacciones por verificar";
        
                    this.setState({
                        verificaciones: resp,
                        preloader: prel,
                        preloader2: ""
                    })
                })
            })
        }

        let cambiaPag = (pag) => (e) => {
            if (verificaciones === undefined) return null;
            if (verificaciones.length === 0) return null;
            this.setState({
                pag: pag,
                preloader2: <i className="fa fa-spinner fa-spin"></i>
            }, () => {
                CantidadVerificaciones((resp1) => {
                    let pags = (resp1) / (this.state.cantVerificaciones.value);
                    let pagis = 0;
                    pagis = parseInt(pags)
                    if (!pags % 1 == 0) pagis ++;
                    this.setState({
                        paginas: pagis,
                        cantVerif: resp1,
                    })
                })
        
                ConsultVerificaciones (this.state.pag, this.state.cantVerificaciones.value, (resp) => {
                    let prel = "";
                    if ((resp.length) === 0) prel = "No tienes transacciones por verificar";
        
                    this.setState({
                        verificaciones: resp,
                        preloader: prel,
                        preloader2: ""
                    })
                })
            })
        }

        let itemsPagInd = () => {
            let items = [];
            for (let i = 1; i <= this.state.paginas; i++) {
                items.push(
                <Pagination.Item key={i} active={i === this.state.pag} onClick={cambiaPag(i)}>
                    {i}
                </Pagination.Item>,
                );
            }
            return items;
        }

        let cambiaPagSelect = (pagSelect) => {
            this.setState({
                pagSelect,
                preloader2: <i className="fa fa-spinner fa-spin"></i>
            }, () => {
                CantidadVerificaciones((resp1) => {
                    let pags = (resp1) / (this.state.cantVerificaciones.value);
                    let pagis = 0;
                    pagis = parseInt(pags)
                    if (!pags % 1 == 0) pagis ++;
                    this.setState({
                        paginas: pagis,
                        cantVerif: resp1,
                    })
                })
        
                ConsultVerificaciones (pagSelect.value, this.state.cantVerificaciones.value, (resp) => {
                    let prel = "";
                    if ((resp.length) === 0) prel = "No tienes transacciones por verificar";
        
                    this.setState({
                        verificaciones: resp,
                        preloader: prel,
                        preloader2: ""
                    })
                })
            })
        }

        let itemsPag = () => {
            if (paginas > maxPaginas){
                let contenido = []
                for (let i = 1; i <= paginas; i++) {
                    contenido.push({
                        value: i, label: `- ${i} -`
                    })
                }

                let funcPaginacion = (operacion) => {
                    this.setState({
                        pagSelect: operacion
                    })
                }

                return(
                    <Row style={{paddingBottom:15, paddingTop: 5}}>
                        <Col md={12} align="center" className="text-danger" style={{fontSize: 11}}><strong>PÁGINA</strong></Col>
                        <Col md={5} align="right" style={{paddingTop: 4}}>
                            <button className="btn btn-primary" onClick={() => {
                                if (pagSelect.value === 1) return null;
                                funcPaginacion({ value: (pagSelect.value) - 1, label: `- ${(pagSelect.value) - 1} -` })
                            }} style={{borderWidth: 1}}><i className="fa fa-chevron-left"></i></button>
                        </Col>
                        <Col md={2} align="center">
                            <Select
                                styles={customStyles}
                                isSearchable ={true}
                                value={pagSelect}
                                onChange={cambiaPagSelect}
                                options={contenido}
                            />
                        </Col>
                        <Col md={5} align="left" style={{paddingTop: 4}}>
                            <button className="btn btn-primary" onClick={() => {
                                if (pagSelect.value > paginas) return null;
                                funcPaginacion({ value: (pagSelect.value) + 1, label: `- ${(pagSelect.value) + 1} -` })
                            }} style={{borderWidth: 1}}><i className="fa fa-chevron-right"></i></button>
                        </Col>
                    </Row>
                )
            }

            return (
                <div align="center">
                    <div align="center" className="text-danger" style={{fontSize: 11, marginBottom: 0}}><strong>PÁGINAS</strong></div>
                    <div><Pagination bsSize="sm" style={{marginTop:0}}>{itemsPagInd()}</Pagination></div>
                </div>
            )
        }

        const VerificacionesS = [
            { value: 10, label: '- Mostrar 10 Verificaciones -' },
            { value: 15, label: '- Mostrar 15 Verificaciones -' },
            { value: 20, label: '- Mostrar 20 Verificaciones -' },
            { value: 30, label: '- Mostrar 30 Verificaciones -' },
            { value: 50, label: '- Mostrar 50 Verificaciones -' },
            { value: "all", label: '- Mostrar Todas -' },
        ];

        const customStyles = {
            menu: (provided) => ({
              ...provided,
              zIndex: 10,
            })
        }

        return(
            <React.Fragment>
                <div className="custom-alert-info" style={{padding:10}}><i className="fa fa-check-square"></i> Verificaciones Pendientes ({cantVerif})</div>
                <Row>
                    <Col md = {12} className="custom-mt-10">
                        <div className="custom-alert-danger">
                            <Row>
                                <Col md={6} style={{paddingTop: 10,}}>
                                    Máximo de verificaciones a mostrar {preloader2}
                                </Col>
                                <Col md={6}>
                                    <Select
                                        styles={customStyles}
                                        isSearchable ={true}
                                        value={cantVerificaciones}
                                        onChange={cambiaVerificaciones}
                                        options={VerificacionesS}
                                    />
                                </Col>
                            </Row>
                        </div>
                    </Col>
                    <Col md={12} className="custom-mt-10">
                        {itemsPag()}
                    </Col>
                </Row>
                <div className="table-responsive" style={{overflowY:"auto", maxHeight: "85vh", overflowX:"hidden"}}>
                    <Table striped hover bordered>
                        <tbody>
                            <tr className="custon-back-color">
                                <td width="40%" style={styles}><strong>Estudiante</strong></td>
                                <td width="60%" style={styles}><strong>Detalles del Pago</strong></td>
                                <td align="center" width="100px" style={styles}><strong>Acciones</strong></td>
                            </tr>
                            {listVerify()}
                        </tbody>
                    </Table>
                </div>
            </React.Fragment>
        )
    }

    render() { 
        return (
            <div className="content">
                <Row>
                    <Col md={8}>
                        {this.contenido()}
                    </Col>
                    <Col md={4}>
                        <div style={{borderRadius: "4px 4px",}}>
                            <CustomCard
                                styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                                category={<span style={{color: "#fff"}}>Verificación de Pagos</span>}
                                color="#a80012"
                                content={this.ayuda()}
                            />
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}
 
export default VerificacionPago;


// WEBPACK FOOTER //
// ./src/views/Administracion/EstadosCuentaContent/VerificacionPago.jsx